import React, { memo } from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { isOpodoAE } from '../../../utils';
import { CurrencyUtils } from '../../../utils/CurrencyUtils';
import { DayPriceEl } from './DayPrice.style';

const getPriceClassNames = ({ cheapest, loading, selected }) => className({
    'odf-text-xs': true,
    'odf-strong': true,
    'odf-text-mono-color-04': !cheapest && !selected,
    'odf-text-positive': !loading && cheapest && !selected,
    'odf-price-selected-loading': loading && selected,
});

const getIconClassNames = (isAE) => className({
    'odf-icon': true,
    'odf-icon-s': true,
    'odf-icon-magnifying-glass': isAE,
    'odf-icon-more': !isAE,
});

export const DayPrice = memo(({ cheapest, hidden, loading, selected, value }) => {
    const isAE = isOpodoAE();
    const classNames = getPriceClassNames({ cheapest, loading, selected });
    const iconClassNames = getIconClassNames(isAE);

    const visibility = hidden ? 'hidden' : 'visible';

    const { getFormattedCalendarFares } = CurrencyUtils();

    if (hidden || loading) {
        return <DayPriceEl loading={loading ? 1 : 0} className={classNames} visibility={visibility} />;
    }

    if (value) {
        return (
            <DayPriceEl className={classNames} visibility={visibility}>
                {getFormattedCalendarFares(value)}
            </DayPriceEl>
        );
    }

    return <DayPriceEl className={iconClassNames} visibility={visibility} />;
});

DayPrice.propTypes = {
    cheapest: PropTypes.bool.isRequired,
    hidden: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    selected: PropTypes.bool.isRequired,
    value: PropTypes.number,
};

DayPrice.defaultProps = {
    value: 0,
};
